import type { IconProps } from './types';

export const ArrowTriangleRightIcon: React.FC<IconProps> = (props) => {
    return (
        <svg
            {...props}
            id="icon-arrowRight-gray"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
        >
            <rect id="Rectangle_3676" data-name="Rectangle 3676" width="16" height="16" fill="none" />
            <path
                id="Polygon_1"
                data-name="Polygon 1"
                d="M4.232.922a1,1,0,0,1,1.536,0L8.633,4.36A1,1,0,0,1,7.865,6H2.135a1,1,0,0,1-.768-1.64Z"
                transform="translate(11 3) rotate(90)"
                fill="currentColor"
            />
        </svg>
    );
};
